import { Grid, Menu, ListItemText, ListItemIcon, Typography, Box, MenuItem, FormControlLabel, Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown, Clear, CloudDownload, PlaylistAddCheck } from '@material-ui/icons';
import { Button, StandardDialog, Toolbar, ConfirmationMenuItem, SelectField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { BulkChangeStatusModal } from './bulkChangeStatusModal';
import { ProtectiveAdvancesSearchBar } from '../protectiveAdvancesSearchBar';
import { CounterPartyExpensesTab, PayableReceivablesTypes, RECEIVABLES_TABS } from '../../types/types';
import { useBaseStore } from '@roc/feature-app-core';
import { ToolbarInfoItem } from '../toolbarInfoItem';
import { useProtectiveAdvancesStore } from '../../hooks/useProtectiveAdvancesStore';

const useStyles = makeStyles(theme => ({
  content: {
    fontWeight: 'bold',
    fontSize: '15px'
  },
  label: {
    fontSize: '13px',
  },
  labelBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  labelBoxCount: {
    marginRight: '25px',
    marginLeft: '25px',
  },
  labelBoxAmount: {
    marginRight: '50px',
    marginLeft: '25px',
  },
  dataPoint: {
    marginTop: '5px',
    textAlign: 'center',
  },
  containerBox: {
    display: 'flex',
  },
  infoItemsBox: {
    marginRight: '40px',
    marginLeft: '25px',
    display: 'flex',
    alignItems: 'center',
    gap: '30px'
  },
}));


export const ReceivablesToolbar = observer(({ tabs, receivablesDashboardStore }) => {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [showBulkActionsMenu, setShowBulkActionsMenu] = useState(false);
  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [statusSelected, setStatusSelected] = useState('');
  const { tab, counterPartyExpenseGridStore, entity } = receivablesDashboardStore;
  const { globalStore } = useBaseStore();
  const {
    protectiveAdvancesStore: { tab: dashboardTab }
  } = useProtectiveAdvancesStore();

  const closeMenu = () => {
    setShowBulkActionsMenu(false);
  };

  const closeChangeStatusModal = () => {
    setStatusSelected('');
    setShowChangeStatusModal(false);
  };

  const saveStatus = () => {
    closeChangeStatusModal();
  }

  const performActions = async (action) => {
    if (receivablesDashboardStore.recordsIds && receivablesDashboardStore.recordsIds.length > 0) {
      await receivablesDashboardStore.performActions(action);
      receivablesDashboardStore.resetToolbarInfo();
      receivablesDashboardStore.setShowSelectedRecords(false);
      counterPartyExpenseGridStore.resetAndFetchGridData();
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please select an item from the table.',
      });
    }
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Toolbar
          left={
            <>
              <Box alignItems="center" display="flex" pr={2}>
                <Typography style={{ paddingRight: '16px' }}>{"Status"}: </Typography>
                <SelectField
                  testId={'typeOfFee'}
                  fullWidth
                  variant="outlined"
                  options={tabs}
                  value={tab}
                  onChange={value => {
                    receivablesDashboardStore.setTab(value);
                  }}
                  required={true}
                  style={{ width: '125px' }}
                />
              </Box>
              <Box>
                <ProtectiveAdvancesSearchBar counterPartyExpenseStore={receivablesDashboardStore} label={"Investor"} />
              </Box>
            </>

          }>
          <Box className={classes.containerBox} >

            <Box className={classes.infoItemsBox}>
              <ToolbarInfoItem value={receivablesDashboardStore.recordsIds.length} label={"Count"} />
              <ToolbarInfoItem value={`${'$'}${receivablesDashboardStore.totalAmount}`} label={"Amount"} />
            </Box>
            <Box style={{ textAlign: 'center', marginRight: '25px' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={receivablesDashboardStore.showSelectedRecords}
                    onChange={(e) => {
                      receivablesDashboardStore.setShowSelectedRecords(!receivablesDashboardStore.showSelectedRecords);
                      counterPartyExpenseGridStore.resetAndFetchGridData()
                    }}
                    color="primary"
                  />
                }
                label={"Show Selected"}
              />
            </Box>
            <Box style={{ textAlign: 'center', marginRight: '25px' }}>
              <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={() => receivablesDashboardStore.exportServicingDashboardData()}
                testId="open_menu"
                variant="contained"
                size="small"
                color="primary"
              >
                Export as Excel
              </Button>
            </Box>
            <Box style={{ textAlign: 'center' }}>
              <div ref={anchorRef} style={{ display: 'inline-block' }}>
                <Button
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={() => { setShowBulkActionsMenu(true) }}
                  testId="open_menu"
                  variant="contained"
                  size="small"
                  color="primary"
                >
                  Bulk Actions <ArrowDropDown style={{ marginRight: '-6px' }} />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorRef.current}
                  open={showBulkActionsMenu}
                  onClose={closeMenu}
                  keepMounted={true}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  getContentAnchorEl={null}
                >
                  {dashboardTab === CounterPartyExpensesTab.RECEIVABLE && (
                    <>
                      {tab === CounterPartyExpensesTab.RECEIVABLE_APPROVED && (
                        <ConfirmationMenuItem
                          testId={`create-bill`}
                          onClick={async () => {
                            performActions(PayableReceivablesTypes.PROCESSING);
                          }}
                          confirmDialogProps={{
                            body: `Are you sure you want to create bill?`,
                          }}
                          disabled={!entity}
                        >
                          <ListItemIcon>
                            <PlaylistAddCheck fontSize="small" />
                          </ListItemIcon>
                          <ListItemText onClick={closeMenu}>Create Bill</ListItemText>
                        </ConfirmationMenuItem>
                      )}
                      {tab != CounterPartyExpensesTab.RECEIVABLE_APPROVED && (
                        <ConfirmationMenuItem
                          testId={`create-bill`}
                          onClick={async () => {
                            performActions(PayableReceivablesTypes.APPROVED);
                          }}
                          confirmDialogProps={{
                            body: `Are you sure you want to reject the selected invoices?`,
                          }}
                        >
                          <ListItemIcon>
                            <PlaylistAddCheck fontSize="small" />
                          </ListItemIcon>
                          <ListItemText onClick={closeMenu}>Approve</ListItemText>
                        </ConfirmationMenuItem>
                      )}

                      <ConfirmationMenuItem
                        testId={`create-bill`}
                        onClick={async () => {
                          performActions('Rejected');
                        }}
                        confirmDialogProps={{
                          body: `Are you sure you want to reject the selected invoices?`,
                        }}
                      >
                        <ListItemIcon>
                          <Clear fontSize="small" />
                        </ListItemIcon>
                        <ListItemText onClick={closeMenu}>Reject</ListItemText>
                      </ConfirmationMenuItem>
                    </>
                  )}

                  {dashboardTab === CounterPartyExpensesTab.BILL && (
                    <>
                      <MenuItem onClick={() => receivablesDashboardStore.downloadBillDocumentsBulk()}>
                        <ListItemIcon>
                          <CloudDownload fontSize="small" />
                        </ListItemIcon>
                        <ListItemText onClick={closeMenu}>Download Invoices Files </ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => receivablesDashboardStore.downloadInvoicesReport()}>
                        <ListItemIcon>
                          <CloudDownload fontSize="small" />
                        </ListItemIcon>
                        <ListItemText onClick={closeMenu}>Download Invoices Report </ListItemText>
                      </MenuItem>
                    </>

                  )}

                </Menu>
              </div>
            </Box>
          </Box>

        </Toolbar>
      </Grid>
      <StandardDialog
        open={showChangeStatusModal}
        title={"Bulk Change Status"}
        maxWidth="sm"
        handleClose={closeChangeStatusModal}
        dialogContent={
          <BulkChangeStatusModal
            options={[
              { label: 'Billed', value: 'Billed' },
              { label: 'Rejected', value: 'Rejected' },
            ]}
            statusSelected={statusSelected}
            handleSelect={setStatusSelected} />
        }
        dialogActions={(
          <>
            <Button
              style={{ marginRight: '8px' }}
              onClick={closeChangeStatusModal}
              color="primary"
              variant="outlined"
              testId="cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={saveStatus}
              color="primary"
              variant="contained"
              testId="confirm"
            >
              Change Status
            </Button>
          </>
        )}
      />
    </Grid>
  );
});
